import { CompanyRepository } from "core/repository";
import { Base2Presenter } from "core/presenter";
import uuid from "uuid";
import * as R from "ramda";

class CustomFieldModalPresenter extends Base2Presenter {
  initialState() {
    return {
      hasChanges: false,
      loading: false,
      fields: []
    };
  }

  onChangeProps() {
    this.enqueue({ fields: R.clone(this.props.customerCustomFields) });
  }

  handleCreateConfigField() {
    const field = {
      uuid: uuid(),
      name: null,
      type: "simple_text",
      options: "",
      required: false,
      created: true
    };

    this.enqueue(vm => ({
      hasChanges: true,
      fields: [...vm.fields, field]
    }));
  }

  async onSendConfigField() {
    this.enqueue({ loading: true });

    const fields = this.viewModel.fields;
    const currentUser = await this.mRuntime.get("currentUser");

    let invalidList = false;

    const customer_custom_fields = fields
      .filter(field => !!field.name)
      .map(field => {
        delete field.created;

        if (field.options) {
          if (typeof field.options !== "object") {
            field.options = field.options.split(",").map(opt => opt.trim());
          }

          if (field.options.length < 2) {
            invalidList = true;
          }
        } else {
          field.options = null;
        }

        return field;
      });

    const updateCompany = await CompanyRepository.update(
      currentUser.company_uuid,
      { customer_custom_fields }
    );

    if (fields.length === 1 && !fields[0].name) {
      this.sendNotification({
        type: "error",
        title: "Oops",
        content: "Não é possivel criar um campo com descrição em branco!"
      });
    } else if (!!invalidList) {
      this.sendNotification({
        type: "error",
        title: "Oops",
        content: "Uma lista deve conter 2 ou mais opções!"
      });
    } else if (updateCompany.success) {
      this.props.onClose(updateCompany.data.customer_custom_fields);
      this.enqueue({ hasChanges: false });
      this.sendNotification({
        type: "success",
        content: "Alterações salvas com sucesso!"
      });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops",
        content:
          "Não foi possível salvar as alterações.\nTente novamente mais tarde ou entre em contato com o suporte."
      });
    }

    this.enqueue({ loading: false });
  }

  onDeleteField(index) {
    const field = this.viewModel.fields[index];
    const name = field.name;

    if (field.created) {
      return this.doDelete(index);
    }

    this.sendNotification({
      type: "confirmation",
      title: "Você tem certeza?",
      content: `Tem certeza que deseja excluir o campo ${name}?\nO campo e os dados nele serão apagados para todos os clientes!`,
      actions: [
        {
          label: "Voltar"
        },
        {
          label: "Sim, quero excluir",
          type: "accent",
          callback: () => this.doDelete(index)
        }
      ]
    });
  }

  doDelete(index) {
    this.enqueue(vm => {
      const fields = [...vm.fields];
      fields.splice(index, 1);
      return { fields, hasChanges: true };
    });
  }

  onChange(field, index, value) {
    this.enqueue(vm => {
      const fields = [...vm.fields];
      fields[index][field] = value;
      return { fields, hasChanges: true };
    });
  }

  onClose() {
    if (this.viewModel.hasChanges) {
      this.sendNotification({
        type: "confirmation",
        title: "Você tem certeza?",
        content:
          'Você realizou alterações. Clique em "Concluir" caso queira salvá-las.\nCaso contrário, serão descartadas.',
        actions: [
          {
            label: "Não, quero voltar!"
          },
          {
            label: "Descartar",
            type: "accent",
            callback: () => this.props.onClose(this.props.customerCustomFields)
          }
        ]
      });
    } else {
      this.props.onClose(this.viewModel.fields);
    }
  }
}

export default CustomFieldModalPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/manage-fields/custom-fields/modal/presenter.js